import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6bfe433e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.scss?vue&type=style&index=0&id=6bfe433e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe433e",
  null
  
)

export default component.exports